export const RevenueSummaryCards = ({ totals }) => (
  <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
    {/* Total Bookings Card */}
    <div className="bg-green-50 p-4 rounded-lg shadow-sm border border-green-100">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-full bg-green-100 text-green-600">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        </div>
        <div>
          <h4 className="text-sm font-medium text-green-800">Total Bookings</h4>
          <p className="text-2xl font-bold text-green-900">{totals.count}</p>
        </div>
      </div>
    </div>

    {/* Total Revenue Card */}
    <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-100">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-full bg-blue-100 text-blue-600">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <h4 className="text-sm font-medium text-blue-800">Total Revenue</h4>
          <p className="text-2xl font-bold text-blue-900">₹{totals.totalAmount.toFixed(2)}</p>
        </div>
      </div>
    </div>

    {/* Theatre Payable Card */}
    <div className="bg-yellow-50 p-4 rounded-lg shadow-sm border border-yellow-100">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-full bg-yellow-100 text-yellow-600">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <div>
          <h4 className="text-sm font-medium text-yellow-800">Theatre Payable</h4>
          <p className="text-2xl font-bold text-yellow-900">₹{totals.theatrePayable.toFixed(2)}</p>
        </div>
      </div>
    </div>

    {/* Cruze Earnings Card */}
    <div className="bg-purple-50 p-4 rounded-lg shadow-sm border border-purple-100">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-full bg-purple-100 text-purple-600">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <div>
          <h4 className="text-sm font-medium text-purple-800">Cruze Earnings</h4>
          <p className="text-2xl font-bold text-purple-900">₹{totals.platformEarnings.toFixed(2)}</p>
        </div>
      </div>
    </div>
  </div>
);